import {
  Component,
  inject,
  OnInit,
  output,
  viewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  UIPopoverDirective,
  UIPopoverRef,
  UIPopoverTargetDirective,
  UIPopoverTemplateDirective
} from '@bannerflow/ui';
import { POPOVER_CONFIG } from '../../../constants';
import { NotificationClickEvent } from '../../../notification.types';
import { NotificationService } from '../../../services/notification.service';
import { NotificationsListComponent } from '../notifications-list/notifications-list.component';
import { PopoverHeaderComponent } from './popover-header/popover-header.component';

@Component({
  imports: [
    UIPopoverTemplateDirective,
    UIPopoverDirective,
    NotificationsListComponent,
    PopoverHeaderComponent
  ],
  selector: 'ns-notification-popover',
  templateUrl: './notification-popover.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './notification-popover.component.scss'
})
export class NotificationPopoverComponent implements OnInit {
  private notificationsService = inject(NotificationService);

  notificationClicked = output<NotificationClickEvent>();

  private popover = viewChild.required<UIPopoverDirective>('popover');

  popoverConfig = POPOVER_CONFIG;

  ngOnInit(): void {
    if (!this.notificationsService.notifications().length) {
      this.notificationsService.loadMoreNotifications();
    }
  }

  openPopover(target: UIPopoverTargetDirective): UIPopoverRef {
    const popover = this.popover();
    if (!popover) {
      throw new Error('Could not find popover child');
    }
    const popoverRef = popover.open(target);
    return popoverRef;
  }

  handleLinkClicked(): void {
    this.popover()?.close();
  }

  handleNotificationClicked(event: NotificationClickEvent): void {
    this.notificationClicked.emit(event);
  }
}
